import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import axios from "axios";
import Batteryicon from "../../../assets/BatteryIcon.png";
import Solaricon from "../../../assets/SolarIcon.png";
import Windicon from "../../../assets/WindIcon.png";
import Gasicon from "../../../assets/GasIcon.png";
import Coalicon from "../../../assets/Coalicon.png";
import Hydroicon from "../../../assets/Hydroicon.png";
import Repicon from "../../../assets/Repicon.png";
import Transmissionicon from "../../../assets/Transmissionicon.png";
import Revenueicon from "../../../assets/TotalRevenue.png";
import TEnergyIcon from "../../../assets/TotalEnergy.png";
import TotalCycle from "../../../assets/TotalAssetCycle.png";
import { useDataContext } from "../../DataContext/PortfolioDataContext";
import { useAssetContext } from "../../DataContext/AssetContext";
import { getAuthToken } from "../../../services/authService-sighup";
// import { datadogLogs } from "@datadog/browser-logs";
import StatCard from "./StateCards";
import { useParams } from "react-router-dom";
import { slugify } from "../slugify";
import { tabsConfig } from "../tabsConfig";
import { useEntitlements } from "../../DataContext/EntitlementsContext";

import { fetchMetricConfig } from "./MetricConfigAPI";
import { MetricGroup } from "./MetricConfig_type";

interface AssetCardProps {
  asset_id: number;
  icon: string;
  asset_name: string;
  asset_type: string;
  totalRevenue: string;
  totalEnergy: string;
  totalCycles: string;
}

interface TabNamesProps {
  activeTabLabel: string;
  onAssetNotFound: (slug: string) => void;
  onAssetFoundName: (name: string) => void;
  assetSlug?: string;
  // refreshCounter?: number;
  refreshCounter: number;
  refreshCounterr: number;


}

const AssetDashboard: React.FC<TabNamesProps> = ({
  activeTabLabel,
  onAssetNotFound,
  onAssetFoundName,
  refreshCounter, 
  refreshCounterr,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { ASSET_ID, ASSET_NAME, ASSET_TYPE, ISO_CODE } = location.state || {};
  const { assetData } = useDataContext();
  const { tab, assetSlug } = useParams<{ tab: string; assetSlug: string }>();

  const { entitlements } = useEntitlements();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [availableAssetNames, setAvailableAssetNames] = useState<string[]>([]);
  const { availableAssets, setAvailableAssets } = useAssetContext();

  const [selectedAssetName, setSelectedAssetName] = useState(ASSET_NAME || "");
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(ASSET_ID || null);
  const {
    selectedAsset,setSelectedAsset,selectedFrequency,selectedDateRange,selectedRevenue,isLoading,setIsLoading,setApiError,setIsDeltaLoading,setGroupedPricingDataAsset,
    setGroupedVolumeDataAsset,setMetricConfigData,setRevenueData,setVolumeData,setPricingData,setNet_Mw_Data,setRevenueMetrics,setVolumeMetrics,setPricingMetrics,
    setRevenueAsset,setVolumeAsset,setPricingAsset,setVolumeDeltaAsset,setVolumeDeltaData,setVolumeDeltaMetrics,GroupBysetRevenueMetrics,
    GroupBysetVolumeMetrics,GroupBysetPricingMetrics,GroupBysetVolumeDeltaMetrics,setNet_Mw_Metrics,selectedResource,setDeltaApiError,
    setIsvolumeLoading,setIspriceLoading,setIsTotalcycleLoading,setIsTotalenergyLoading,isTotalcycleLoading,isTotalenergyLoading,setSelectedAssetNameContext,selectedMeasures,
    intervalAlignment,
    searchTrigger,
    resetFilters,
  } = useAssetContext();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAssetData, setSelectedAssetData] =
    useState<AssetCardProps | null>(null);
  const [allRevenueData, setAllRevenueData] = useState<any[]>([]);
  const [allVolumeData, setAllVolumeData] = useState<any[]>([]);
  const [allPricingData, setAllPricingData] = useState<any[]>([]);
  const [allVolumeDeltaData, setAllVolumeDeltaData] = useState<any[]>([]);
  const [allTotalCycleData, setAllTotalCycleData] = useState<any[]>([]);
  const [allTotalEnergyData, setAllTotalEnergyData] = useState<any[]>([]);
  const [, setTotalCycleData] = useState<any[]>([]);
  const [, setTotalEnergyData] = useState<any[]>([]);
  const [, setTotalRevenueData] = useState<any[]>([]);
  const [allNetMwData, setAllNetMwData] = useState<any[]>([]);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [allgroupedPricingData, setAllGroupedPricingData] = useState<any[]>([]);
  const [allgroupedVolumeData, setAllGroupedVolumeData] = useState<any[]>([]);
  const [showLoading, setShowLoading] = useState(false);
  const [hasRequested, setHasRequested] = useState(false);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (assetData && Array.isArray(assetData)) {
      const assets = assetData.map((item: any) => ({
        asset_id: item.asset_id,
        asset_name: item.asset_name,
        asset_type: item.asset_type,
        iso_code: item.ISO,
      }));

      const uniqueAssets = Array.from(
        new Map(assets.map((asset) => [asset.asset_name, asset])).values()
      );

      setAvailableAssets(uniqueAssets);
      localStorage.setItem("assetTypesData", JSON.stringify(uniqueAssets));
    }

    if (!assetData || !Array.isArray(assetData)) {
      const stored = localStorage.getItem("assetTypesData");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (Array.isArray(parsed)) {
            setAvailableAssets(parsed);
          }
        } catch (_) {}
      }
    }
  }, [assetData,refreshCounter,refreshCounterr]);

  useEffect(() => {
    if (selectedAssetId && selectedDateRange) {
      setHasRequested(true);
      setShowLoading(true);
    }
  }, [selectedAssetId, searchTrigger, refreshCounter, refreshCounterr]);

  useEffect(() => {
    if (hasRequested && !isLoading) {
      setShowLoading(false);
    }
  }, [isLoading, hasRequested,refreshCounter,refreshCounterr]);

  const getAssetIcon = (type: string) => {
    switch (type) {
      case "Gas":
        return Gasicon;
      case "Solar":
        return Solaricon;
      case "Wind":
        return Windicon;
      case "Coal":
        return Coalicon;
      case "Hydro":
        return Hydroicon;
      case "Battery":
        return Batteryicon;
      case "Rep":
        return Repicon;
      case "Transmission":
        return Transmissionicon;
      default:
        return Batteryicon;
    }
  };

  const getFriendlyErrorMessage = (err: unknown, context: string) => {
    let code: number | undefined;

    if (typeof err === "object" && err !== null) {
      const e = err as any;
      code = e?.error?.code || e?.response?.status;

      const rawMessage =
        e?.error?.message || e?.message || e?.error?.error?.message;
      if (!code && typeof rawMessage === "string") {
        const match = rawMessage.match(/^(\d{3}):/);
        if (match) {
          code = parseInt(match[1]);
        }
      }
    }

    switch (code) {
      case 401:
        return "You're not authorized to access this content. Please log in or check your access permissions.";
      case 403:
        return "You need permission to access this site.";
      case 404:
        return "Data not found.";
      case 500:
        return "Server error while fetching data. Please try again later.";
      default:
        break;
    }

    return "Something went wrong while fetching data.";
  };

  const getRequestContext = async (selectedDateRange: string) => {
    const token = await getAuthToken();
    if (!token) throw new Error("Failed to retrieve authentication token.");

    const baseUrl = process.env.REACT_APP_ANALYTICS_API as string;
    const subscriptionKey = process.env
      .REACT_APP_SUBSCRIPTION_KEY_TIMESERIES as string;

    const headers = {
      Authorization: `Bearer ${token}`,
      "Ocp-Apim-Subscription-Key": subscriptionKey ?? "",
      Product: process.env.REACT_APP_PRODUCT_APIM,
    };

    let start_date: string | undefined;
    let end_date: string | undefined;

    if (selectedDateRange?.includes(" - ")) {
      [start_date, end_date] = selectedDateRange.split(" - ");
    } else {
      start_date = selectedDateRange;
    }

    return { baseUrl, headers, start_date, end_date };
  };

  const fetchAndCache = async (
    _key: string,
    call: () => Promise<any>,
    onSuccess: (data: any) => void,
    onError: (err: any) => void,
    _isCacheable?: boolean,
    _forceRefresh?: boolean
  ) => {
    try {
      const result = await call();
      onSuccess(result);
    } catch (err) {
      onError(err);
    }
  };
  // const metricConfigCache = useRef<Record<string, any>>({});

  useEffect(() => {
    const fetchPrimaryData = async () => {
      if (
        !selectedAssetId ||
        !selectedDateRange ||
        !selectedFrequency ||
        !selectedRevenue ||
        !selectedResource
      )
        return;

      setApiError({});
      setDeltaApiError({});
      setIsLoading(true);

      const { baseUrl, headers, start_date, end_date } =
        await getRequestContext(selectedDateRange);
      const isCacheable = !(
        selectedDateRange === "today" || selectedDateRange === "day_ahead"
      );
      const userEmail = localStorage.getItem("userEmail");
      const basePayload = {
        filters: {
          asset_id: { operator: "EQ", value: Number(selectedAssetId) },
        },
        date_range: { start_date, ...(end_date ? { end_date } : {}) },
        time_granularity: selectedFrequency || "hour",
        ...(intervalAlignment !== "industry" && { interval_alignment: intervalAlignment }),
        user: userEmail || "",
      };

      const groupByCondition = (metric_group: string) =>
        selectedRevenue?.length > 0 &&
        (metric_group === "ASSET_SETTLEMENT_DETAIL" ||
          metric_group === "ASSET_VOLUMEDELTA_DETAIL");

      const metric_groupEndpointMap = {
        "Estimated Settlements": {
          metric_group: "ASSET_SETTLEMENT_DETAIL",
          endpoint: "revenue/",
          operation: "GET_ASSET_SETTLEMENT_DETAIL",
          setter: setRevenueData,
          metricSetter: setRevenueMetrics,
          allSetter: setAllRevenueData,
          groupBySetter: GroupBysetRevenueMetrics,
          setLoading: setIsLoading,
        },
        Volume: {
          metric_group: "ASSET_VOLUME_DETAIL",
          endpoint: "volume/",
          operation: "GET_ASSET_VOLUME_DETAIL",
          setter: setVolumeData,
          metricSetter: setVolumeMetrics,
          allSetter: setAllVolumeData,
          groupBySetter: GroupBysetVolumeMetrics,
          setLoading: setIsvolumeLoading,
        },
        Price: {
          metric_group: "ASSET_PRICE_DETAIL",
          endpoint: "pricing/",
          operation: "GET_ASSET_PRICING_DETAIL",
          setter: setPricingData,
          metricSetter: setPricingMetrics,
          allSetter: setAllPricingData,
          groupBySetter: GroupBysetPricingMetrics,
          setLoading: setIspriceLoading,
        },
      };

      const requests: Promise<void>[] = [];

      const metricConfig =
        metric_groupEndpointMap[
          activeTabLabel as keyof typeof metric_groupEndpointMap
        ];
      if (metricConfig) {
        metricConfig.setLoading(true);
        const payload = {
          ...basePayload,
          metric_group: metricConfig.metric_group,
          operation: metricConfig.operation,
          ...(groupByCondition(metricConfig.metric_group) && {
            group_by: selectedRevenue,
          }),
        };

        const cacheKey = `${selectedAssetId}-${selectedRevenue}-${
          metricConfig.metric_group
        }-${start_date}-${
          end_date || ""
        }-${selectedFrequency}-${selectedResource}-${intervalAlignment}`;

        requests.push(
          fetchAndCache(
            cacheKey,
            () =>
              axios
                .post(`${baseUrl}/${metricConfig.endpoint}`, payload, {
                  headers,
                })
                .then((res) => res.data),
            (resData) => {
              const { data, request } = resData;
              metricConfig.setter(data || []);
              metricConfig.metricSetter(request?.metrics || []);
              metricConfig.allSetter(data || []);
              metricConfig.groupBySetter(request?.group_by_metrics || []);
              metricConfig.setLoading(false);
              if (data.length === 0) {
                setApiError({
                  message:
                    "We couldn’t find any data for the selected asset. Try changing your filters or come back later.",
                });
              }
              metricConfig.setLoading(false);
            },
            (err) => {
              const finalMessage = getFriendlyErrorMessage(
                err,
                metricConfig.metric_group
              );
              setApiError({ message: finalMessage });
              metricConfig.setLoading(false);
            },
            isCacheable
          ).finally(() => metricConfig.setLoading(false))
        );
      }

      if (activeTabLabel === "Estimated Settlements") {
        setIsDeltaLoading(true);
        const deltaPayload = {
          ...basePayload,
          metric_group: "ASSET_VOLUMEDELTA_DETAIL",
          operation: "GET_ASSET_VOLUMEDELTA_DETAIL",
          ...(groupByCondition("ASSET_VOLUMEDELTA_DETAIL") && {
            group_by: selectedRevenue,
          }),
        };

        const deltaKey = `${selectedAssetId}-${selectedRevenue}-ASSET_VOLUMEDELTA_DETAIL-${start_date}-${
          end_date || ""
        }-${selectedFrequency}-${selectedResource}-${intervalAlignment}`;

        requests.push(
          fetchAndCache(
            deltaKey,
            () =>
              axios
                .post(`${baseUrl}/volume/delta`, deltaPayload, { headers })
                .then((res) => res.data),
            (resData) => {
              const { data, request } = resData;
              setVolumeDeltaData(data || []);
              setVolumeDeltaMetrics(request?.metrics || []);
              setAllVolumeDeltaData(data || []);
              GroupBysetVolumeDeltaMetrics(request?.group_by_metrics || []);
              if (data.length === 0) {
                setDeltaApiError({
                  message:
                    "We couldn’t find any data for the selected asset. Try changing your filters or come back later.",
                });
              }
              setIsDeltaLoading(false);
            },
            (err) => {
              const finalMessage = getFriendlyErrorMessage(
                err,
                metricConfig.metric_group
              );
              setDeltaApiError({ message: finalMessage });
              setIsDeltaLoading(false);
            },
            isCacheable
          )
        );
      }

      if (selectedFrequency) {
        const freqCacheKey = `${selectedAssetId}-${selectedRevenue}-METERED_OUTPUT-${start_date}-${end_date}-${selectedFrequency}-${selectedResource}`;
        const userEmail = localStorage.getItem("userEmail");
        if (activeTabLabel === "Estimated Settlements") {
          const freqPayload = {
            filters: {
              asset_id: { operator: "EQ", value: Number(selectedAssetId) },
            },
            date_range: { start_date, ...(end_date ? { end_date } : {}) },
            time_granularity: selectedFrequency || "hour",
            operation: "GET_ASSET_METER_MW_LINE",
            user: userEmail || "",
            metrics: ["METERED_OUTPUT"],
          };

          fetchAndCache(
            freqCacheKey,
            () =>
              axios
                .post(`${baseUrl}/volume/`, freqPayload, { headers })
                .then((res) => res.data),
            (resData) => {
              setAllNetMwData(resData?.data || []);
              setNet_Mw_Metrics(resData?.request?.metrics || []);
            },
            () => {
              setAllNetMwData([]);
              setNet_Mw_Metrics([]);
            },
            isCacheable
          );
        }
      }

      await Promise.allSettled(requests);
      setIsLoading(false);
      setIsDeltaLoading(false);
    };

    fetchPrimaryData();
  }, [selectedAssetId, searchTrigger, refreshCounter, refreshCounterr, activeTabLabel]);

  useEffect(() => {
    if (
      !selectedAssetId ||
      !selectedDateRange ||
      !selectedFrequency ||
      !selectedResource
    )
      return;

    const fetchTotals = async () => {
      const { baseUrl, headers, start_date, end_date } =
        await getRequestContext(selectedDateRange);

      const isCacheable = !(
        selectedDateRange === "today" || selectedDateRange === "day_ahead"
      );

      const userEmail = localStorage.getItem("userEmail");
      const basePayload = {
        filters: {
          asset_id: { operator: "EQ", value: Number(selectedAssetId) },
        },
        date_range: { start_date, ...(end_date ? { end_date } : {}) },
        time_granularity: selectedFrequency || "hour",
        user: userEmail || "",
      };

      const promises: Promise<void>[] = [];

      setIsTotalenergyLoading(true);
      promises.push(
        fetchAndCache(
          `${selectedAssetId}-TOTAL_ENERGY-${start_date}-${end_date}-${selectedResource}`,
          () =>
            axios
              .post(
                `${baseUrl}/volume/`,
                {
                  ...basePayload,
                  operation: "GET_ASSET_TOTAL_ENERGY",
                  group_by: "total",
                  metrics: ["METERED_OUTPUT"],
                  group_by_granularity: "true",
                },
                { headers }
              )
              .then((res) => res.data),
          (resData) => {
            const totalEnergyData = resData?.data || [];
            const totalEnergyAsset = totalEnergyData.find(
              (item: any) => String(item.ASSET_ID) === String(selectedAssetId)
            );

            setAllTotalEnergyData(totalEnergyData);
            if (Array.isArray(totalEnergyAsset?.RESOURCES) && totalEnergyAsset.RESOURCES.length > 0) {
              setSelectedAsset((currentAsset: any) =>
                currentAsset && String(currentAsset.asset_id) === String(selectedAssetId)
                  ? { ...currentAsset, RESOURCES: totalEnergyAsset.RESOURCES }
                  : currentAsset
              );
            }
          },
          () => setAllTotalEnergyData([]),
          isCacheable
        ).finally(() => setIsTotalenergyLoading(false))
      );

      if ((selectedAsset?.asset_type ?? "").toLowerCase() === "battery") {
        setIsTotalcycleLoading(true);
        promises.push(
          fetchAndCache(
            `${selectedAssetId}-TOTAL_CYCLE-${start_date}-${end_date}-${selectedResource}`,
            () =>
              axios
                .post(
                  `${baseUrl}/volume/total-cycle`,
                  {
                    ...basePayload,
                    operation: "GET_ASSET_TOTAL_CYCLE",
                    group_by: "total",
                    group_by_granularity: "true",
                  },
                  { headers }
                )
                .then((res) => res.data),
            (resData) => setAllTotalCycleData(resData?.data || []),
            () => setAllTotalCycleData([]),
            isCacheable
          ).finally(() => setIsTotalcycleLoading(false))
        );
      }

      // Total Revenue stat card — fetch on every tab so it is always populated
      const storedEntitlements: { po_path: string }[] = JSON.parse(
        localStorage.getItem("entitlements") || "[]"
      );
      const isEntitledToRevenue = storedEntitlements.some(
        (e) =>
          e.po_path?.toLowerCase().trim() ===
          "/asset-dashboard/estimated-settlements"
      );
      if (isEntitledToRevenue && selectedRevenue) {
        const totalRevenueCacheKey = `${selectedAssetId}-TOTAL_REVENUE-${start_date}-${
          end_date || ""
        }-${selectedFrequency}-${selectedRevenue}-${selectedResource}`;
        promises.push(
          fetchAndCache(
            totalRevenueCacheKey,
            () =>
              axios
                .post(
                  `${baseUrl}/revenue/`,
                  {
                    ...basePayload,
                    metric_group: "ASSET_SETTLEMENT_DETAIL",
                    operation: "GET_ASSET_SETTLEMENT_DETAIL",
                    group_by: selectedRevenue,
                  },
                  { headers }
                )
                .then((res) => res.data),
            (resData) => {
              if (resData?.data?.length) setAllRevenueData(resData.data);
            },
            () => {
              // silent fail — don't clobber data already set by Estimated Settlements tab
            },
            isCacheable
          )
        );
      }

      // run all in parallel
      await Promise.allSettled(promises);
    };

    fetchTotals();
  }, [selectedAssetId, searchTrigger, refreshCounter, refreshCounterr]);

  useEffect(() => {
    const fetchMetricConfigData = async () => {
      try {
        const tabCategoryMap: Record<string, string> = {
          price: "PRICING",
          volume: "VOLUME",
        };

        const isCacheable = !(
          selectedDateRange === "today" || selectedDateRange === "day_ahead"
        );

        const normalizedTabLabel = activeTabLabel.trim().toLowerCase();
        const category = tabCategoryMap[normalizedTabLabel] || null;

        const asset = availableAssets.find(
          (a) => a.asset_name === selectedAssetName
        );
        const iso_code = asset?.iso_code || ISO_CODE;
        const fuel_type = asset?.asset_type?.toLowerCase() || undefined;

        if (category && iso_code && selectedAssetId) {
          const groupByField = "AWARD_TYPE";
          const cacheKey = `${selectedAssetId}-METRIC_CONFIG-${iso_code}-${category}-${groupByField}-${fuel_type || ""}`;

          await fetchAndCache(
            cacheKey,
            async () => {
              const res = await fetchMetricConfig({
                iso_code,
                category,
                group_by: groupByField,
                fuel_type,
              });

              const rawData = (res?.response?.data ?? []) as MetricGroup[];

              // filter out invalid groups + deduplicate group_key + deduplicate metrics
              const seenGroups = new Set<string>();

              return rawData
                .filter(
                  (g) =>
                    g.group_key &&
                    g.group_key.trim().length > 0 &&
                    !seenGroups.has(g.group_key.trim()) &&
                    seenGroups.add(g.group_key.trim())
                )
                .map((g) => ({
                  ...g,
                  metric_list: Array.from(new Set(g.metric_list)),
                }));
            },
            (data) => setMetricConfigData(data || []),
            (err) => {
              console.error("Failed to fetch metric config:", err);
              setMetricConfigData([]);
            },
            isCacheable
          );
        }
      } catch (err) {
        console.error("Unexpected error in fetchMetricConfigData:", err);
        setMetricConfigData([]);
      }
    };

    fetchMetricConfigData();
  }, [selectedAssetId, activeTabLabel,refreshCounter,refreshCounterr]);

  useEffect(() => {
    const fetchGroupedData = async () => {
      const userEmail = localStorage.getItem("userEmail");
      if (activeTabLabel !== "Estimated Settlements") return;
      if (!selectedAssetId || !selectedDateRange || !selectedFrequency || !selectedRevenue || !selectedResource
      )
        return;

      const { baseUrl, headers, start_date, end_date } =
        await getRequestContext(selectedDateRange);
      const basePayload = {
        filters: {
          asset_id: { operator: "EQ", value: Number(selectedAssetId) },
        },
        date_range: { start_date, ...(end_date ? { end_date } : {}) },
        time_granularity: selectedFrequency || "hour",
        ...(intervalAlignment !== "industry" && { interval_alignment: intervalAlignment }),
        user: userEmail || "",
      };
      const isCacheable = !(
        selectedDateRange === "today" || selectedDateRange === "day_ahead"
      );

      const extraRequests: Promise<void>[] = [];

      // --- Grouped Price Call ---
      if (selectedMeasures.includes("Price")) {
        const groupedPricePayload = {
          ...basePayload,
          metric_group: "ASSET_PRICE_DETAIL",
          group_by: selectedRevenue,
          operation: "GET_ASSET_PRICING_DETAIL",
          ...(selectedRevenue !== "total" && { group_by_granularity: "false" }),
        };
        const priceGroupedKey = `${selectedAssetId}-${selectedRevenue}-GROUPED_PRICE-${start_date}-${
          end_date || ""
        }-${selectedFrequency}-${selectedResource}-${intervalAlignment}`;

        extraRequests.push(
          fetchAndCache(
            priceGroupedKey,
            () =>
              axios
                .post(`${baseUrl}/pricing/`, groupedPricePayload, { headers })
                .then((res) => res.data),
            (resData) => setAllGroupedPricingData(resData?.data || []),
            () => setAllGroupedPricingData([]),
            // isCacheable
            isCacheable,
            refreshCounterr > 0 
          )
        );
      }

      // --- Grouped Volume Call ---
      if (selectedMeasures.includes("Megawatts")) {
        const groupedVolumePayload = {
          ...basePayload,
          metric_group: "ASSET_VOLUME_DETAIL",
          group_by: selectedRevenue,
          operation: "GET_ASSET_VOLUME_DETAIL",
          ...(selectedRevenue !== "total" && { group_by_granularity: "false" }),
        };
        const volumeGroupedKey = `${selectedAssetId}-${selectedRevenue}-GROUPED_VOLUME-${start_date}-${
          end_date || ""
        }-${selectedFrequency}-${selectedResource}-${intervalAlignment}`;

        extraRequests.push(
          fetchAndCache(
            volumeGroupedKey,
            () =>
              axios
                .post(`${baseUrl}/volume/`, groupedVolumePayload, { headers })
                .then((res) => res.data),
            (resData) => setAllGroupedVolumeData(resData?.data || []),
            () => setAllGroupedVolumeData([]),
            // isCacheable
            isCacheable,
            refreshCounterr > 0 
          )
        );
      }

      await Promise.allSettled(extraRequests);
    };

    fetchGroupedData();
  }, [selectedMeasures, selectedAssetId, searchTrigger, refreshCounter, refreshCounterr, activeTabLabel]);

  useEffect(() => {
    if (
      selectedAssetName &&
      (allRevenueData.length > 0 || allVolumeData.length > 0 || allPricingData.length > 0 || allVolumeDeltaData.length > 0 || allNetMwData.length > 0 ||
        allTotalCycleData.length > 0 || allTotalEnergyData.length > 0 || allgroupedPricingData.length > 0 || allgroupedVolumeData.length > 0)
    ) {
      const revenueAsset = allRevenueData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const volumeAsset = allVolumeData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const pricingAsset = allPricingData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const VolumeDeltaAsset = allVolumeDeltaData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const NetMwData = allNetMwData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const TotalCycle = allTotalCycleData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const TotalEnergy = allTotalEnergyData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const PricingGrouped = allgroupedPricingData.find((item: any) => item.ASSET_NAME === selectedAssetName);
      const VolumeGrouped = allgroupedVolumeData.find( (item: any) => item.ASSET_NAME === selectedAssetName);
      const TotalRevenueValue = selectedResource === "ALL" ? revenueAsset?.TOTAL_REVENUE ?? null : revenueAsset?.RESOURCES.find((res: any) => res.RESOURCE_NAME === selectedResource)?.TOTAL_REVENUE ?? null;
      const TotalenergyValue =selectedResource === "ALL"? TotalEnergy?.TOTAL ?? null: TotalEnergy?.RESOURCES.find((res: any) => res.RESOURCE_NAME === selectedResource)?.TOTAL ?? null;
      const TotalCycleValue =selectedResource === "ALL"? TotalCycle?.TOTAL ?? null: TotalCycle?.RESOURCES.find((res: any) => res.RESOURCE_NAME === selectedResource)?.TOTAL ?? null;
      const isDataAvailable = revenueAsset || volumeAsset || pricingAsset || VolumeDeltaAsset || TotalCycle || TotalEnergy || TotalRevenueValue;

      if (isDataAvailable) {
        const resourceSources = activeTabLabel === "Volume"
          ? [volumeAsset, TotalEnergy, revenueAsset, pricingAsset, VolumeDeltaAsset]
          : activeTabLabel === "Price"
          ? [pricingAsset, TotalEnergy, revenueAsset, volumeAsset, VolumeDeltaAsset]
          : [revenueAsset, TotalEnergy, volumeAsset, pricingAsset, VolumeDeltaAsset];
        const resources = resourceSources.find(
          (source) => Array.isArray(source?.RESOURCES) && source.RESOURCES.length > 0
        )?.RESOURCES || [];
        const assetData = {asset_id: revenueAsset?.ASSET_ID || volumeAsset?.ASSET_ID || pricingAsset?.ASSET_ID || VolumeDeltaAsset?.ASSET_ID || selectedAsset?.asset_id,
          icon: getAssetIcon(selectedAsset?.asset_type),
          asset_name: selectedAssetName,
          asset_type:revenueAsset?.ASSET_TYPE ||volumeAsset?.ASSET_TYPE ||  pricingAsset?.ASSET_TYPE || VolumeDeltaAsset?.ASSET_TYPE || selectedAsset?.asset_type,
          iso_code: revenueAsset?.ISO_CODE || volumeAsset?.ISO_CODE || pricingAsset?.ISO_CODE || VolumeDeltaAsset?.ISO_CODE || selectedAsset?.ISO,
          totalRevenue: TotalRevenueValue?.toString() ?? "",
          totalEnergy: TotalenergyValue?.toString() ?? "",
          totalCycles: TotalCycleValue?.toString() ?? "",
          RESOURCES: resources, };

        setRevenueAsset(revenueAsset); setVolumeAsset(volumeAsset); setPricingAsset(pricingAsset); setVolumeDeltaAsset(VolumeDeltaAsset);
        setNet_Mw_Data(NetMwData); setTotalRevenueData(TotalRevenueValue); setTotalEnergyData(TotalenergyValue); setTotalCycleData(TotalCycleValue);
        setGroupedPricingDataAsset(PricingGrouped); setGroupedVolumeDataAsset(VolumeGrouped); setSelectedAsset(assetData); setSelectedAssetData(assetData);
      } else {
        // Reset state when no data is available
        setRevenueAsset(null); setVolumeAsset(null); setPricingAsset(null); setVolumeDeltaAsset(null); setNet_Mw_Data([]);
        setTotalRevenueData([]); setTotalEnergyData([]); setTotalCycleData([]); setSelectedAsset(null); setSelectedAssetData(null);
      }
    } else {
      // If arrays are empty, clear everything
      setRevenueAsset(null); setVolumeAsset(null); setPricingAsset(null); setVolumeDeltaAsset(null); setNet_Mw_Data([]);
      setTotalRevenueData([]); setTotalEnergyData([]); setTotalCycleData([]); setSelectedAsset(null); setSelectedAssetData(null);
    }
  }, [selectedAssetName,allRevenueData, allVolumeData,allPricingData,allVolumeDeltaData,allNetMwData,allTotalCycleData,
    allTotalEnergyData,allgroupedPricingData,allgroupedVolumeData,selectedResource,activeTabLabel,refreshCounter,refreshCounterr]);

  const handleArrowClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleAssetSelect = (name: string) => {
    const selectedAsset = availableAssets.find(
      (asset) => asset.asset_name === name
    );
    if (!selectedAsset) return;

    const assetSlug = slugify(selectedAsset.asset_name);
    const entitledPaths = entitlements.map((e) =>
      e.po_path.toLowerCase().trim()
    );

    const assetData = {
      asset_id: selectedAsset.asset_id,
      asset_name: selectedAsset.asset_name,
      asset_type: selectedAsset.asset_type,
      iso_code: selectedAsset.iso_code,
      icon: getAssetIcon(selectedAsset.asset_type),
      totalRevenue: "",
      totalEnergy: "",
      totalCycles: "",
    };

    // Update state — reset filters when a new asset is chosen
    resetFilters();
    setSelectedAsset(assetData);
    setSelectedAssetData(assetData);
    setSelectedAssetName(selectedAsset.asset_name);
    setSelectedAssetId(selectedAsset.asset_id);
    setIsDropdownOpen(false);
    setSearchTerm("");

    // Determine the correct tab slug
    const currentTabSlug = tab; // from route params
    const validTabSlug = entitledPaths.includes(
      `/asset-dashboard/${currentTabSlug}`
    )
      ? currentTabSlug
      : tabsConfig.tabs
          .map((t) => slugify(t.label))
          .find((slug) => entitledPaths.includes(`/asset-dashboard/${slug}`));

    if (!validTabSlug) {
      console.warn("No accessible tab found for user.");
      return;
    }

    // Always navigate (removes overly aggressive early-return issue)
    navigate(`/asset-dashboard/${validTabSlug}/${assetSlug}`, {
      state: {
        ASSET_ID: selectedAsset.asset_id,
        ASSET_NAME: selectedAsset.asset_name,
        ASSET_TYPE: selectedAsset.asset_type,
      },
    });
  };

  // Keep selected asset in sync with URL
  useEffect(() => {
    if (!assetSlug || availableAssets.length === 0) return;

    const matchedAsset = availableAssets.find(
      (asset) => slugify(asset.asset_name) === assetSlug.toLowerCase()
    );

    if (matchedAsset) {
      setSelectedAsset((currentAsset: any) =>
        currentAsset &&
        String(currentAsset.asset_id) === String(matchedAsset.asset_id) &&
        currentAsset.asset_name === matchedAsset.asset_name
          ? currentAsset
          : matchedAsset
      );
      setSelectedAssetId(matchedAsset.asset_id);
      setSelectedAssetName(matchedAsset.asset_name);
      setSelectedAssetNameContext(matchedAsset.asset_name);
      onAssetFoundName(matchedAsset.asset_name);
    } else {
      onAssetNotFound(assetSlug);
    }
  }, [assetSlug, availableAssets, onAssetNotFound, onAssetFoundName,refreshCounter,refreshCounterr]);

  const filteredAssets = availableAssets.filter(
    (asset) =>
      typeof asset.asset_name === "string" &&
      asset.asset_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const asset = availableAssets.find((a) => a.asset_name === selectedAssetName);
  useEffect(() => {
    if (selectedAssetName || ASSET_NAME) {
      setSelectedAssetNameContext(selectedAssetName || ASSET_NAME);
    }
  }, [selectedAssetName, ASSET_NAME, setSelectedAssetNameContext,refreshCounter,refreshCounterr]);

  // console.log(availableAssets)

  return (
    <div className="bg-[#F7F7FF] p-6 ml-6">
      <div className="flex items-center gap-2 mb-4">
        <img
          src={getAssetIcon(
            availableAssets.find((a) => a.asset_name === selectedAssetName)
              ?.asset_type || ASSET_TYPE
          )}
          alt="Icon"
          className="w-6 h-6 mb-7 md:w-8 md:h-8"
        />
        <div className="relative flex flex-col">
          <h2
            className="text-3xl md:text-5xl font-bold mb-2 ml-2 cursor-pointer"
            onClick={handleArrowClick}
          >
            {selectedAssetName || ASSET_NAME}
          </h2>
          <div className="flex justify-end text-xs md:text-sm text-gray-500 font-poppins pr-2">
            {(() => {
              const asset = availableAssets.find(
                (a) => a.asset_name === selectedAssetName
              );
              const iso = asset?.iso_code || ISO_CODE;
              const type = asset?.asset_type || ASSET_TYPE;
              return (
                <>
                  <span className="mr-4">{iso}</span>
                  <span>{type}</span>
                </>
              );
            })()}
          </div>
        </div>
      </div>

      {isDropdownOpen && (
        <div
          ref={dropdownRef}
          className="absolute ml-10 bg-white shadow-lg mt-1 p-4 w-full max-w-[280px] border z-10 max-h-[400px] overflow-y-auto"
        >
          <div className="relative w-full">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 pl-10 border rounded-md"
            />
          </div>
          {filteredAssets.length > 0 ? (
            filteredAssets.map((asset, index) => (
              <div
                className="flex items-center gap-2 mt-2 cursor-pointer"
                key={index}
              >
                <input
                  type="radio"
                  id={asset.asset_name}
                  name="assetType"
                  value={asset.asset_name}
                  checked={selectedAssetName === asset.asset_name}
                  onChange={() => handleAssetSelect(asset.asset_name)}
                  className="mr-2"
                />
                <label
                  htmlFor={asset.asset_name}
                  className="text-sm md:text-xl font-poppins break-words cursor-pointer"
                >
                  {asset.asset_name}
                </label>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 text-center">
              No results found
            </p>
          )}
        </div>
      )}

      {activeTabLabel !== "Asset Revenue" && (
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-5">
        <StatCard
          icon={Revenueicon}
          label="Total Revenue"
          round={false}
          formatCompact={true}
          value={
            selectedAssetData?.totalRevenue != null
              ? Number(selectedAssetData.totalRevenue)
              : undefined
          }
          isLoading={showLoading}
          showCard={
            (selectedAssetData?.totalRevenue != null &&
              Number(selectedAssetData.totalRevenue) !== 0) ||
            (showLoading && selectedAssetData?.totalRevenue == null)
          }
          decimalPlaces={2}
        />

        <StatCard
          icon={TEnergyIcon}
          label="Total Energy"
          round={false}
          unit="MWh"
          decimalPlaces={2}
          formatCompact={true}
          value={
            selectedAssetData?.totalEnergy != null
              ? Number(selectedAssetData.totalEnergy)
              : undefined
          }
          isLoading={isTotalenergyLoading}
          showCard={
            (selectedAssetData?.totalEnergy != null &&
              Math.abs(Number(selectedAssetData.totalEnergy)) >= 0.01) ||
            (isTotalenergyLoading && selectedAssetData?.totalEnergy == null)
          }
        />

        <StatCard
          icon={TotalCycle}
          label="Total Cycles"
          round={true}
          formatCompact={false}
          value={
            selectedAssetData?.totalCycles != null
              ? Number(selectedAssetData.totalCycles)
              : undefined
          }
          unit="%"
          isLoading={
            asset?.asset_type?.toLowerCase() === "battery" &&
            isTotalcycleLoading
          }
          showCard={
            asset?.asset_type?.toLowerCase() === "battery" &&
            ((selectedAssetData?.totalCycles != null &&
              Math.round(Number(selectedAssetData.totalCycles)) !== 0) ||
              (isTotalcycleLoading && selectedAssetData?.totalCycles == null))
          }
        />
      </div>
      )}
    </div>
  );
};

export default AssetDashboard;
